module.exports = __webpack_public_path__ + "img/rct-logo.1de80979.png";